import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "new_components/PropertyManagement/PropertyManagement.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import ComingSoon from "new_assets/new_images/Builders/coming_soon.png";
import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
// import ComingSoon from "new_assets/new_images/Builders/coming_soon.png";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import PreLoad from "new_components/PreLoad/PreLoad";
import HomeBottomBanner from "new_components/Home/HomeBottomBanner";
const PropertyManagement = () => {
  return (
    <>
      <ScrollToTopDefault />
      <ProgressCircle />
      <Header />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <div>
      <PropertyManagementBanner />
      <PropertySolutions />
      <RentalListings />
      <PropertyListings />
      <HomeBottomBanner />
      {/* <QuoteSection /> */}
    </div>
  );
};

const PropertyManagementBanner = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const Preload = () => {
    return (
      <div className="preload preload-container">
        <div className="preload-logo">
          <div className="spinner" />
          <span className="icon icon-villa-fill" />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.PropertyManagementBanner);
        if (
          response.data?.status === "success" &&
          response.data?.data?.length
        ) {
          setData(response.data.data[0]);
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <Preload />
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp propertymanagementbanner mx-md-5 px-1 px-md-5"
          style={{
            backgroundImage: `url(${Image_Base_URL + data.image})`,
          }}
          data-wow-delay=".2s"
        >
          <div className="col-12 text-center">
            <p className="subtitle text-white body-2 wow fadeInUp">
              {data?.title1 || "Welcome to"}{" "}
            </p>
            <h3 className="title text-white">
              {data?.title2 || "LUCKY DUCK ASSET MANAGEMENT"}
            </h3>
          </div>
          <div className="col-12 align-items-left">
            <p
              className="subtitle text-white body-2 wow fadeInUp px-5"
              dangerouslySetInnerHTML={{
                __html: data?.description || "No Description",
              }}
            ></p>

            <button
              className="tf-btn btn-view primary hover-btn-view ml-5 mt-3"
              onClick={() => {
                const url = new URL(data.button_url, window.location.origin);
                window.open(url.toString(), "_blank");
                // window.location.href = url.toString();
              }}
            >
              {data.button_text || "Contact Us"}{" "}
              <span className="icon icon-arrow-right2"></span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const PropertySolutions = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.PropertySolutions);
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          setData(response.data.data[0]); // Get the first object from the data array
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <section className="flat-section bg-primary-new">
      <div className="container">
        <div className="box-title text-center wow fadeInUp">
          <h3 className="mt-4 title">{data.title}</h3>
        </div>
        <div
          className="row align-items-center justify-content-center wow fadeInUp"
          data-wow-delay=".2s"
        >
          <div className="col-12 col-md-4 text-center mb-2 propertysol">
            <img
              src={`${Image_Base_URL}${data.image}`}
              alt="Investment strategy illustration"
            />
          </div>
          <div className="col-12 col-md-8">
            <div
              className="investmentphildata note body-2"
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const RentalListings = () => {
  const [RentalListingsData, setRentalListingsData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.PropertyMgmntCta);
        setRentalListingsData(response.data.data); // Access the "data" array from the response
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch Rental Listings.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="row dualbannerlistingrow">
      {RentalListingsData.map((item) => (
        <React.Fragment key={item.id}>
          <div className="col-12 col-md-6 dualbannerlistingone">
            <h6 className="title text-white">{item.title}</h6>
            {/* <p className="body-2 text-white">{item.sub_title}</p> */}
            <br />
            <Link
              to={item.button_link}
              className="tf-btn btn-view primary hover-btn-view ml-5 dualbannerlistingonebtn"
            >
              {item.button_text}{" "}
              <span className="icon icon-arrow-right2 dualbannerlistingonebtnicon"></span>
            </Link>
          </div>
          <div
            className="col-12 col-md-6 dualbannerlistingsecpic"
            style={{
              backgroundImage: `url(${Image_Base_URL}${item.image})`, // Dynamically set background image
            }}
          ></div>
        </React.Fragment>
      ))}
    </section>
  );
};

const PropertyModal = ({ property }) => {
  const modalId = `propertyModal-${property.id || "default"}`;
  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      aria-labelledby={`${modalId}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={`${modalId}Label`}>
              {property.title || "Property Details"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row align-items-center">
              <div className="col-12">
                {/* Ensure description is sanitized on the server-side to prevent XSS */}
                <div
                  className="aboutuspageteammemberdesc"
                  dangerouslySetInnerHTML={{
                    __html:
                      property.modal_description || "No description available.",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PropertyListings = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [sectionTitle, setSectionTitle] = useState("Property Listings");
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(apiUrls.PropertyMgmntproperties);
        if (response.data.status === "success") {
          // Ensure each property has a unique id
          const propertiesWithIds = response.data.data.map((prop, index) => ({
            ...prop,
            id: prop.id || `prop-${index}`, // Fallback ID if prop.id is missing
          }));
          setProperties(propertiesWithIds);
        } else {
          setError("Failed to fetch properties. Please try again later.");
        }
      } catch (err) {
        setError("An error occurred while fetching the properties.");
      }
    };

    const fetchSectionTitle = async () => {
      try {
        const response = await axios.get(apiUrls.PropertyMgmntListingtitle);
        if (response.data.status === "success") {
          setSectionTitle(response.data.data.section_title);
        }
      } catch (err) {
        console.warn("Failed to fetch section title:", err);
        // Optional: keep default section title if error occurs
      }
    };

    fetchProperties();
    fetchSectionTitle();
  }, []);

  const totalPages = Math.ceil(properties.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProperties = properties.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);
  const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  return (
    <section className="flat-section pb-0">
      <div className="container py-5 bg-primary-new">
        <div className="box-title wow fadeInUp closedInv">
          <h3 className="title text-uppercase">{sectionTitle}</h3>
        </div>
        <div className="completed-projects">
          <div>
            {error ? (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            ) : currentProperties.length > 0 ? (
              <>
                {currentProperties.map((property) => (
                  <div
                    key={property.id}
                    className="row mb-5 closedprop bg-white"
                  >
                    <div className="buildercompletedprojectshero col-12 col-md-4 col-xl-2 text-center">
                      <img
                        src={Image_Base_URL + (property.image || "")}
                        alt={property.title || "Property Image"}
                        className="project-image"
                      />
                    </div>
                    <div className="col-12 col-md-8 col-xl-10 p-md-3 pl-lg-4 pb-2">
                      <div className="row align-items-center body-2 fw-bold pb-2">
                        <div className="col-12 col-sm-auto">
                          <span className="badge bg-success rounded-pill me-2">
                            {property.comingSoon || "N/A"}
                          </span>
                        </div>
                        <div className="col-12 col-xl-auto">
                          {property.title || "Untitled Property"}
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-12 col-sm-6 col-xl-4 pb-md-2 pb-1">
                          Sq Ft Under AC:{" "}
                          <span className="fw-bold">
                            {property.sq_ft_under_ac || "N/A"}
                          </span>
                        </div>
                        <div className="col-12 col-sm-6 col-xl-4 pb-md-2 pb-1">
                          Outdoor Living:{" "}
                          <span className="fw-bold">
                            {property.sq_ft_exterior_living || "N/A"}
                          </span>
                        </div>
                        <div className="col-12 col-sm-6 col-xl-4 pb-md-2 pb-1">
                          Garage:{" "}
                          <span className="fw-bold">
                            {property.sq_ft_garage || "N/A"}
                          </span>
                        </div>
                        {/* <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                      Each Unit SqFt:{" "}
                      <span className="fw-bold">
                        {property.each_unit_sqft || "N/A"}
                      </span>
                    </div>
                    <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                      Total Property:{" "}
                      <span className="fw-bold">
                        {property.total_property || "N/A"}
                      </span>
                    </div> */}
                      </div>
                      <div className="row mb-2">
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              property.description ||
                              "No description available.",
                          }}
                        />
                      </div>
                      <div className="row pt-1 fw-bold">
                        {(property.amenities || []).map((amenity, index) => (
                          <div
                            key={index}
                            className="col-12 col-lg-6 col-xl-4 pb-md-2 pb-1"
                          >
                            {amenity}
                          </div>
                        ))}
                      </div>
                      <div className="row mt-3">
                        <div className="col">
                          <button
                            className="btn rounded-pill fw-bold body-2 pm-seemorebtn"
                            data-bs-toggle="modal"
                            data-bs-target={`#propertyModal-${property.id}`}
                          >
                            {property.modal_btn_text || "See More"}
                          </button>
                        </div>
                        <div className="col-auto">
                          <a
                            href={property.button_link || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn rounded-pill fw-bold body-2 pm-btn primary"
                          >
                            {property.button_text || "Learn More"}
                          </a>
                        </div>
                      </div>
                    </div>
                    <PropertyModal property={property} />
                  </div>
                ))}
              </>
            ) : (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            )}
          </div>

          {totalPages > 1 && (
            <div className="pagination-controls text-center">
              <button
                className="btn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className="btn"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

// const QuoteSection = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(apiUrls.bottomBanner);
//         if (
//           response.data.status === "success" &&
//           response.data.data.length > 0
//         ) {
//           setData(response.data.data[0]);
//         } else {
//           throw new Error(
//             "Invalid API response structure or no data available."
//           );
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="text-center">
//         <PreLoad />
//       </div>
//     );
//   }

//   if (error) {
//     return <div className="text-center text-danger">Error: {error}</div>;
//   }

//   return (
//     <section className="flat-section">
//       <div className="container">
//         <div
//           className="row align-items-center justify-content-center wow fadeInUp ldgquote mx-md-5"
//           data-wow-delay=".2s"
//           style={{ backgroundImage: `url(${Image_Base_URL}${data.bg_image})` }}
//         >
//           <div className="col-12 text-center">
//             <h3 className="title text-white">
//               {data?.title || "Title not available"}
//             </h3>
//             <div className="note body-2 text-white pt-2">
//               {data?.footer_text || "Description not available"}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

export default PropertyManagement;
